<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<realWarehouse v-if="activeTab == '1'" ref="realWarehouse"></realWarehouse>
			<twoDimension v-if="activeTab == '2'" ref="twoDimension"></twoDimension>
		</topTab>
	</div>
</template>

<script>
import realWarehouse from "./realWarehouse.vue";
import twoDimension from "./twoDimension.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "实时库存"
				},
				{
					key: "2",
					value: "二维表库存"
				}
			]
		};
	},
	// 注册组件
	components: {
		realWarehouse,
		twoDimension
	},
	created() {},
	computed: {},
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped>
.one_1 {
	background-color: rgb(253, 175, 5);
	display: block;
}
</style>
